

export function getSelectedLanguageFromLocalStorage() {
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    // (async function(){await new Promise(resolve => setTimeout(resolve, 1000))})()    
    return selectedLanguage ?? 'tr-TR'
}

export function setSelectedLanguageToLocalStorage(selectedLanguage) {
    localStorage.setItem('selectedLanguage', selectedLanguage);
}


export function getUserFromLocalStorage() {
    return JSON.parse(localStorage.getItem("user"))
}

export function setUserToLocalStorage(user) {
    localStorage.setItem("user", JSON.stringify(user))
}